import React from "react";
import styles from "./FilterButtonsLoadingSkeleton.module.scss";

const FiltersButtonsLoadingSkeleton = () => {
  return (
    <div className={styles.filterButtonsLoadingSkeleton}>
      <div className={styles.filterButtons}>
        <div>
          <div className={styles.filterLoadingButton} />
        </div>
        <div>
          <div className={styles.filterLoadingButton} />
        </div>
        <div>
          <div className={styles.filterLoadingButton} />
        </div>
        <div>
          <div className={styles.filterLoadingButton} />
        </div>
      </div>
    </div>
  );
};

export default FiltersButtonsLoadingSkeleton;
